import React, { useState, useEffect } from 'react';
import useSidebarStyle from '../hooks/sidebarStyle';
import { Icon, Button } from 'native-base';
import { useNavigation } from '@react-navigation/native';

export default function HamburgerMenu() {
	const { drawerType } = useSidebarStyle();
	const navigation = useNavigation();
	if (drawerType == 'permanent') return null;

	return (
		<Button transparent rounded androidRippleColor="white" onPress={() => navigation.toggleDrawer()}>
			<Icon active name="menu" />
		</Button>
	);
}
